// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__e8mtV","savePackageButton":"ClientWallet_savePackageButton__SGhWg"};